export function extractDomainFromUrl(url: string): string {
  try {
    let cleanUrl = url.trim().toLowerCase();
    if (!cleanUrl.startsWith('http://') && !cleanUrl.startsWith('https://')) {
      cleanUrl = 'https://' + cleanUrl;
    }
    const parsed = new URL(cleanUrl);
    let hostname = parsed.hostname.toLowerCase();
    if (hostname.startsWith('www.')) {
      hostname = hostname.slice(4);
    }
    return hostname;
  } catch {
    return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0].toLowerCase().trim();
  }
}

export function extractDomainFromEmail(email: string): string {
  const parts = email.trim().toLowerCase().split('@');
  if (parts.length > 1) {
    let domain = parts[1];
    if (domain.startsWith('www.')) {
      domain = domain.slice(4);
    }
    return domain;
  }
  return '';
}

export function checkDomainMatch(email: string, websiteUrl: string): boolean {
  const emailDomain = extractDomainFromEmail(email);
  const siteDomain = extractDomainFromUrl(websiteUrl);
  if (!emailDomain || !siteDomain) return false;
  return (
    emailDomain === siteDomain ||
    siteDomain.endsWith('.' + emailDomain) ||
    emailDomain.endsWith('.' + siteDomain)
  );
}
